import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoadingSkeleton from "./components/loading.js";
import ProtectedRoute from "./scripts/protectedRoute";

const Alarmes = lazy(() => import("./pages/dashboard/home/alarms.js"));
const Eventos = lazy(() => import("./pages/dashboard/home/events.js"));
const Historico = lazy(() => import("./pages/dashboard/home/history.js"));
const DetailsGeneral = lazy(
  () => import("./pages/dashboard/details/general/detailsGeneral.js"),
);
const Logs = lazy(() => import("./pages/audit-logs/logs"));
const Arvore = lazy(() => import("./pages/register/tree/tree.js"));
const Recursos = lazy(() => import("./pages/register/resources/resources.js"));
const Usuarios = lazy(() => import("./pages/register/users/users.js"));
const UsuariosGrupo = lazy(
  () => import("./pages/register/users/groups/usersGroups.js"),
);
const Perfil = lazy(() => import("./pages/profiles/profiles.js"));
const Login = lazy(() => import("./pages/login/login.js"));
const EsqueceuSenha = lazy(() => import("./pages/login/forgotPassword.js"));
const SemPermissao = lazy(() => import("./components/pageNoPermission.js"));
const NaoEncontrada = lazy(() => import("./components/pageNotFound.js"));

const AppRoutes = () => (
  <Suspense fallback={<LoadingSkeleton />}>
    <Routes>
      <Route path="/" element={<Navigate to="/home/eventos" replace />} />
      <Route path="/home" element={<Navigate to="/home/eventos" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/esqueceuSenha" element={<EsqueceuSenha />} />
      <Route path="/semPermissao" element={<SemPermissao />} />
      <Route
        path="/home/eventos"
        element={
          <ProtectedRoute>
            <Eventos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home/alarmes"
        element={
          <ProtectedRoute>
            <Alarmes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home/historico"
        element={
          <ProtectedRoute>
            <Historico />
          </ProtectedRoute>
        }
      />
      <Route
        path="/home/detalhes-gerais"
        element={
          <ProtectedRoute>
            <DetailsGeneral />
          </ProtectedRoute>
        }
      />
      <Route
        path="/arvore"
        element={
          <ProtectedRoute slugPermission="front_assets">
            <Arvore />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recursos"
        element={
          <ProtectedRoute slugPermission="front_resources">
            <Recursos />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute slugPermission="front_users">
            <Usuarios />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute slugPermission="front_audit_logs">
            <Logs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usuarios/grupos"
        element={
          <ProtectedRoute slugPermission="front_roles">
            <UsuariosGrupo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/perfil"
        element={
          <ProtectedRoute>
            <Perfil />
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NaoEncontrada />
          </ProtectedRoute>
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
